/**
 * 09 §5.8 "Not found": `הדף שחיפשת לא קיים`, with one next step. Never a raw 404, never a blank page.
 */

import { AppShell } from '../shell/AppShell';
import { StateBlock } from '../components/StateBlock';
import { routes } from '../routes';

export function NotFoundScreen(): JSX.Element {
  return (
    <AppShell titleHe="הדף שחיפשת לא קיים">
      <StateBlock
        titleHe="הדף שחיפשת לא קיים"
        bodyHe="ייתכן שהקישור ישן, או שהדף הועבר למקום אחר במערכת."
        nextStep={
          <a className="btn btn--primary" href={routes.companies}>
            חזרה לחברות שלי
          </a>
        }
      />
    </AppShell>
  );
}
